export default {
  namespaced: true,
  state: {
    produtos: [],
    idCarrinho: null,
    cupomDesconto: 0,
    dadosCupomDesconto: null,
    contador: 0,
    pagamentoConcluido: false,
    total: 0
  },
  getters: {
    valorTotal (state) {
      return state.produtos.map(p => p.quantidade * p.valorUnitario)
        .reduce((total, atual) => (total + atual) - state.cupomDesconto, 0)
    },
    getProduto: (state) => (id) => {
      return state.produtos.find(produto => produto.id === id)
    },
    contadorProdutos (state) {
      return state.contador
    },
    idCarrinho (state) {
      return state.idCarrinho
    }
  },
  mutations: {
    contadorProdutos (state, payload) {
      state.contador = payload
    },
    idCarrinho (state, payload) {
      state.idCarrinho = payload
    },
    atualizarProduto (state, payload) {
      for (var i in state.produtos) {
        if (state.produtos[i].id === payload.id) {
          state.produtos[i].quantidade = state.produtos[i].quantidade + payload.quantidade
        }
      }
    },
    adicionarUnidadeProduto (state, payload) {
      for (var i in state.produtos) {
        if (state.produtos[i].id === payload.id) {
          state.produtos[i].quantidade = state.produtos[i].quantidade + 1
        }
      }
    },
    removerUnidadeProduto (state, payload) {
      for (var i in state.produtos) {
        if (state.produtos[i].id === payload.id) {
          state.produtos[i].quantidade = state.produtos[i].quantidade - 1
        }
      }
    },
    limparCarrinho (state) {
      state.produtos = []
      state.contador = 0
      state.idCarrinho = null
    },
    adicionarProduto (state, payload) {
      state.produtos.push(payload)
    },
    removerProduto (state, payload) {
      state.produtos = state.produtos.filter((obj) => {
        return obj.id !== payload
      })
    },
    limparIdCarrinho (state) {
      state.idCarrinho = null
    },
    pagamentoConcluido (state, payload) {
      state.pagamentoConcluido = payload
    },
    cupomDesconto (state, payload) {
      state.cupomDesconto = payload
    },
    dadosCupomDesconto (state, payload) {
      state.dadosCupomDesconto = payload
    },
    destroiCupom (state) {
      state.dadosCupomDesconto = null
      state.cupomDesconto = 0
    },
    total (state, payload) {
      state.total = payload
    },
    somaTotal (state, payload) {
      state.total = state.total + payload
    },
    diminuiTotal (state, payload) {
      state.total = state.total - payload
    }
  },
  actions: {
    contadorProdutos ({ commit }, payload) {
      commit('contadorProdutos', payload)
    },
    idCarrinho ({ commit }, payload) {
      commit('idCarrinho', payload)
    },
    removerUnidadeProduto ({ commit }, payload) {
      commit('removerUnidadeProduto', payload)
    },
    adicionarUnidadeProduto ({ commit }, payload) {
      commit('adicionarUnidadeProduto', payload)
    },
    limparCarrinho ({ commit }, payload) {
      commit('limparCarrinho', payload)
    },
    limparIdCarrinho ({ commit }, payload) {
      commit('limparIdCarrinho', payload)
    },
    adicionarProduto ({ commit }, payload) {
      commit('adicionarProduto', payload)
    },
    removerProduto ({ commit }, payload) {
      commit('removerProduto', payload)
    },
    atualizarProduto ({ commit }, payload) {
      commit('atualizarProduto', payload)
    },
    pagamentoConcluido ({ commit }, payload) {
      commit('pagamentoConcluido', payload)
    },
    cupomDesconto ({ commit }, payload) {
      commit('cupomDesconto', payload)
    },
    dadosCupomDesconto ({ commit }, payload) {
      commit('dadosCupomDesconto', payload)
    },
    total ({ commit }, payload) {
      commit('total', payload)
    },
    somaTotal ({ commit }, payload) {
      commit('somaTotal', payload)
    },
    diminuiTotal ({ commit }, payload) {
      commit('diminuiTotal', payload)
    },
    destroiCupom ({ commit }, payload) {
      commit('destroiCupom', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/carrinho.js